import React, { useEffect } from 'react'
import Layout from '../SectionLayout/layout'
import SectionTitle from '../../components/section_title/section_title'
import Video from './video/Video'
import './showscene.scss'

import JSONConfig from '../../config'

import white_img_a from '../../assets/white_img_a.png'
import white_img_b from '../../assets/white_img_b.png'
import white_img_c from '../../assets/white_img_c.png'
import white_img_d from '../../assets/white_img_d.png'

import post1 from '../../assets/poster1.png'
import post2 from '../../assets/poster2.png'
import post3 from '../../assets/poster3.png'
import post4 from '../../assets/poster4.png'


function ShowScene() {
  const { videos } = JSONConfig

  return <Layout>
    <div className="show_scene_container">
      <SectionTitle subtitle="快速嵌入各类版式页面，升级3D互动展销" type="black">奥本未来3D云服务应用场景展示</SectionTitle>
      <Video type="right" key={14} uri={videos[0]} imguri={white_img_a} title="广告Banner位" subtitle="3D升级应用" poster={post1} />
      <Video type="left" key={24} uri={videos[1]} imguri={white_img_b} title="沉浸感通栏" subtitle="3D升级应用" poster={post2} />
      <Video type="right" key={34} uri={videos[2]} imguri={white_img_c} title="产品详情" subtitle="3D升级应用" poster={post3} />
      <Video type="left" key={44} uri={videos[3]} imguri={white_img_d} title="单品焦点" subtitle="3D升级应用" poster={post4} />
    </div>
  </Layout>
}

export default ShowScene
